//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const checkboxOne = ref(true)
    const checkboxTwo = ref(false)

    return { checkboxOne, checkboxTwo }
  },
}
